import React from "react";
import {Radio, Grid, Hidden, Typography} from "@material-ui/core";
import Fab from "@material-ui/core/es/Fab/Fab";
import style from "./style";
import Button from "@material-ui/core/Button/Button";
import ListItem from "@material-ui/core/ListItem";
import InputField from "../../components/Field";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import moment from 'moment';
import { FETCH_LAST_SUBSCRIPTION } from "../../graphql/queries/chef";
import GetCardType from '../../utils/card-type';
import DinerButton from '../../components/DinerButton';
import { client } from '../../config/apollo';

const amex = "/images/amex.webp";
const discover = "/images/discover.webp";
const dinersclub = "/images/dinersclub.webp";
const jcb = "/images/jcb.webp";
const mastercard = "/images/mastercard.webp";
const visa = "/images/visa.webp";
const unionpay = "/images/unionpay.webp";

const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{4})$/;
const VerifySchema = Yup.object().shape({
  firstName: Yup.string().required("first name is required"),
  middleName: Yup.string(),
  lastName: Yup.string().required("last name is required"),
  phone: Yup.string()
    .matches(/^(\d{10})$/, {
      message: "Must be atleast 10 digits",
      excludeEmptyString: true
    }).required("phone number is required"),
  email: Yup.string()
    .email("enter valid email")
    .required("email is required"),
  dob: Yup.string()
    .matches(/^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$/, {
      message: "Enter a valid date. Example MM/DD/YYYY",
      excludeEmptyString: true
    }).required("date of birth is required"),
  zip: Yup.string().required("ZIP Code is required"),
  ssn: Yup.string()
    .matches(/^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/, {
      message: "Incorrect format. Example 000-00-0000",
      excludeEmptyString: true
    })
    .required("ssn is required"),
  cardNumber: Yup.string().required("card number is required"),
  expiry: Yup.string()
    .matches(expiryRegex, {
      message: "Incorrect format. Example MM/YYYY",
      excludeEmptyString: true
    })
    .required("expiry is required"),
  cvv: Yup.string()
    .min(3, "enter valid cvv")
    .max(4, "enter valid cvv")
    .required("cvv is required"),
  cardName: Yup.string()
});

class VerifyChef extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardType: "",
      addCard: false,
      userCards: [],
      selectedCard: null,
      selectedCardIndex: 0,
      date: props.details.chef && props.details.chef.dateOfBirth ? moment(props.details.chef.dateOfBirth).format('MM/DD/YYYY') : moment("1970-01-01").format('MM/DD/YYYY'),
      lastSubscription: null,
      isCardMandatory: true,
    };
  }

  toggleCard = () => {
    this.setState({ addCard: !this.state.addCard });
    if (this.props.fetchPayments) {
      this.props.fetchPayments.refetch();
    }
  };

  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };
    if (!!this.props.details.chef && !!this.props.details.chef.dateOfBirth) {
      this.setState({ date: moment(this.props.details.chef.dateOfBirth).format('MM/DD/YYYY') });
    } else {
      this.setState({ date: moment("1970-01-01").format('MM/DD/YYYY') });
    }

    const user = this.props.fetchPayments.user;
    if (user && user.paymentInfo && user.paymentInfo.length && user.paymentInfo.length > 0) {
      this.setState({ userCards: user.paymentInfo });
    } else {
      this.props.fetchPayments.refetch();
    }

    client
      .query({
        query: FETCH_LAST_SUBSCRIPTION,
        variables: {
          chefId: this.props.userId
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        const { data } = response;

        this.setState({
          lastSubscription: data.fetchSubscription
        });

        if (data.fetchSubscription) {
          const { price } = data.fetchSubscription;
          if (price < 400) {
            this.setState({isCardMandatory: true});
            this.props.setSubscirptionAndCard(data.fetchSubscription, true);
          } else {
            this.setState({isCardMandatory: false});
            this.props.setSubscirptionAndCard(data.fetchSubscription, false);
          }
        }
      })
      .catch(err => console.log('ERR fetching SUBSCRIPTION on Verify screen'))
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (!!this.props.details.chef && !!this.props.details.chef.dateOfBirth) {
        this.setState({ date: moment(this.props.details.chef.dateOfBirth).format('MM/DD/YYYY') });
      }
      else {
        this.setState({ date: moment("1970-01-01").format('MM/DD/YYYY') });
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.fetchPayments && props.fetchPayments.user && props.fetchPayments.user.paymentInfo) {
      const updatedState = {
        userCards: props.fetchPayments.user.paymentInfo
      };
      return updatedState;
    }
    return null;
  }

  render() {
    const { values, details } = this.props;

    let zip =
      details.chef && details.chef.address ? details.chef.address.zip : "";
    /*let initialValues = {};
    if (!!values) {
      initialValues = {
        firstName: values.user.firstName || "",
        middleName: values.user.middleName || "",
        lastName: values.user.lastName || "",
        email: values.user.emailId || "",
        dob: this.state.date,
        zip: zip || "",
        ssn: values.user.ssn || "",
        phone: values.user.cellPhone || "",
        cardNumber: "",
        cardName: "",
        cvv: "",
        expiry: ""
      };
    }*/

    const userCards = this.state.userCards.map((payment, index) => {
      if (payment) {
        return (
          <ListItem
            divider
            style={{ display: "flex", padding: 0, justifyContent: 'space-between', flexDirection: 'row' }}
          >
            <div>
              <Radio color="primary" checked={this.state.selectedCardIndex === index} onChange={() => this.setState({ selectedCard: payment.card, selectedCardIndex: index })} />
            </div>
            <div>
              <p>
                ************{payment.card.last4}
              </p>
            </div>
            <div>
              <img src={payment.card.type.toLowerCase().startsWith('visa') ? visa : (
                payment.card.type.toLowerCase().startsWith('master') ? mastercard : (
                  payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ? amex : (
                    payment.card.type.toLowerCase().startsWith('disco') ? discover : (
                      payment.card.type.toLowerCase().startsWith('diner') ? dinersclub : (
                        payment.card.type.toLowerCase().startsWith('jc') ? jcb : unionpay
                      )
                    )
                  )
                )
              )} style={style.cardImgInput} />
            </div>

          </ListItem>
        );
      } else {
        return (<></>);
      }

    });

    return (
      <div className="chef-right-col">
        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Become a verified chef
            </p>
            <div className="cont-btn">
              <DinerButton />
            </div>
          </div>
        </div>
        {!!details.chef && details.chef.verificationInitiated ? (
          <>
            <p style={style.subHeaderText}>
              Thank you. We will get the ball rolling on getting you verified!
            </p>
            <Grid container>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                className="verify-step-button-container-ok"
              >
                <Button className="remind-later-btn" data-test-id={"remind-id-continue"} onClick={this.props.onSkip}>Continue</Button>
              </Grid>
            </Grid>
          </>
        ) :
          !!details.chef && details.chef.verified ? (
            <>
              <p style={style.subHeaderText}>
                Thank you. You have been successfully verified!
              </p>
              <Grid container>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  className="verify-step-button-container-ok"
                >
                  <Button className="remind-later-btn" data-test-id={"remind-id-continue"} onClick={this.props.onSkip}>Continue</Button>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              {this.state.isCardMandatory ? (<p style={style.subHeaderText}>
                  We strongly encourage you to become a Verified Chef, as you are more
                  likely to get engagement requests. Becoming a Verified Chef requires
                  a background check that will cost $50.
                </p>) : (<p style={style.subHeaderText}>
                  We strongly encourage you to become a Verified Chef, as you are more
                  likely to get engagement requests. Becoming a Verified Chef requires
                  a background check that is covered in your subscription plan.
                </p>)}


          <p style={style.subHeaderText}>
          If you choose to be verified, you will receive an email from our background check provider, Checkr, inviting you to provide the needed information for verification.
          </p>

          <Grid container>
          <Grid
          item
          lg={12}
          md={12}
          sm={12}
          className="verify-step-button-container"
          >
          <Button className="remind-later-btn" data-test-id={"remind-id"} onClick={this.props.onSkip}>Remind me later</Button>
          <Fab
          data-test-id={"verifysub"}
          variant={"extended"}
          disabled={this.props.loading}
          type="submit"
          id={"verify-submit"}
          onClick={() => {
          document.getElementById('verify-submit').disabled=true;
          this.props.onVerify(values);
        }}
          style={
          this.props.loading
          ? style.submitButtonDisabled
          : style.submitButton
        }
          >
          Yes, Get me Verified
          </Fab>
          </Grid>
          </Grid>
            </>
        )}

        {/*<h4 align="left" style={style.textFont}>
          Personal Details
        </h4>*/}
        {/*<Formik
          initialValues={{ ...initialValues, ...{ dob: this.state.date } }}
          validationSchema={VerifySchema}
          enableReinitialize
          onSubmit={values => {
          document.getElementById('verify-submit').disabled = true;
          this.props.onSubmit(values);
          }}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <Form>
              <Grid container>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"firstName"}
                    placeholder={"Enter First Name"}
                    error={errors.firstName && touched.firstName}
                    errorMessage={errors.firstName}
                    label={"FIRST NAME"}
                    type={"text"}
                  />
                </Grid>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"middleName"}
                    placeholder={"Enter Middle Name"}
                    error={errors.middleName && touched.middleName}
                    errorMessage={errors.middleName}
                    label={"MIDDLE NAME"}
                    type={"text"}
                  />
                </Grid>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"lastName"}
                    placeholder={"Enter Last Name"}
                    error={errors.lastName && touched.lastName}
                    errorMessage={errors.lastName}
                    label={"LAST NAME"}
                    type={"text"}
                  />
                </Grid>
                <Grid item lg={6} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"email"}
                    placeholder={"Enter Email"}
                    error={errors.email && touched.email}
                    errorMessage={errors.email}
                    label={"EMAIL"}
                    type={"text"}
                  />
                </Grid>
                <Grid item lg={6} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"dob"}
                    placeholder={"MM/DD/YYYY"}
                    error={errors.dob && touched.dob}
                    errorMessage={errors.dob}
                    label={"DATE OF BIRTH"}
                    type={"date"}
                    value={this.state.date}
                    onChange={date => this.setState({ date })}
                  />
                  <InputField
                    name={"dob"}
                    placeholder={"MM/DD/YYYY"}
                    error={errors.dob && touched.dob}
                    errorMessage={errors.dob}
                    label={"DATE OF BIRTH"}
                    type={"text"}
                    masked={true}
                    mask={"99/99/9999"}
                  />
                </Grid>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"phone"}
                    placeholder={"Enter Phone"}
                    error={errors.phone && touched.phone}
                    errorMessage={errors.phone}
                    label={"PHONE"}
                    type={"text"}
                    inputType={"number"}
                  />
                </Grid>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"ssn"}
                    placeholder={"Enter SSN again"}
                    error={errors.ssn && touched.ssn}
                    errorMessage={errors.ssn}
                    label={"SSN"}
                    type={"text"}
                    masked={true}
                    mask={"999-99-9999"}
                  />
                </Grid>
                <Grid item lg={4} xs={12} style={style.fieldContainer}>
                  <InputField
                    name={"zip"}
                    placeholder={"Enter Zip"}
                    error={errors.zip && touched.zip}
                    errorMessage={errors.zip}
                    label={"ZIP"}
                    type={"text"}
                    inputType={"text"}
                  />
                </Grid>
                {this.state.isCardMandatory && <Grid container>
                  <Grid item lg={12} xs={12} style={{padding: '0 10px'}}>
                    <h4 className="add-card-heading" align="left" style={style.textFont}>
                      Saved Card
                    </h4>
                  </Grid>
                  <Grid item lg={6} xs={12} style={{padding: '0 10px', marginBottom: 30}}>
                    {this.state.userCards.length > 0 ? userCards : <Typography>No cards added</Typography>}
                  </Grid>
                </Grid>}
                {this.state.isCardMandatory && <Hidden xsUp>
                  <Grid item lg={12} xs={12} style={{textAlign: "center", padding: '0 10px'}}>
                    <Fab
                      data-test-id={"addnew-id"}
                      variant={"extended"}
                      color={"primary"}
                      style={style.submitButton}
                      onClick={() => this.toggleCard()}
                    >
                      Add new card
                    </Fab>
                  </Grid>
                </Hidden>}

                {this.state.isCardMandatory && <Hidden xsDown>
                  <Grid item lg={12} xs={12} style={{textAlign: "left", padding: '0 10px'}}>
                    <Fab
                      data-test-id={"addnew-id"}
                      variant={"extended"}
                      color={"primary"}
                      style={style.submitButton}
                      onClick={() => this.toggleCard()}
                    >
                      Add new card
                    </Fab>
                  </Grid>
                </Hidden>}
                <Hidden smUp>
                  <Grid
                    item
                    lg={12}
                    xs={12}
                    style={{ textAlign: "center", marginTop: 10 }}
                  >
                    <Fab
                      variant={"extended"}
                      color={"primary"}
                      style={style.submitButton}
                      onClick={() => this.toggleCard()}
                    >
                      Add new card
                    </Fab>
                  </Grid>
                </Hidden>
                {this.state.addCard && (
                  <Grid container>
                    <Grid item lg={7} xs={12} style={style.fieldContainer}>
                      <Grid style={{position: 'relative'}}>
                        <InputField
                          name={"cardNumber"}
                          placeholder={"0000-0000-0000-0000"}
                          error={errors.cardNumber && touched.cardNumber}
                          errorMessage={errors.cardNumber}
                          label={"CARD NUMBER"}
                          type={"text"}
                          onBlur={() => {
                            const cardType = GetCardType(values.cardNumber.replace(/-/g, ''));
                            this.setState({ cardType });
                          }}
                          masked={true}
                          mask={"9999-9999-9999-9999"}
                          fullWidth
                        />
                        <img
                          src={this.state.cardType.toLowerCase().startsWith('visa') ? visa : (
                            this.state.cardType.toLowerCase().startsWith('master') ? mastercard : (
                              this.state.cardType.toLowerCase().startsWith('american') || this.state.cardType.toLowerCase().startsWith('amex') ? amex : (
                                this.state.cardType.toLowerCase().startsWith('disco') ? discover : (
                                  this.state.cardType.toLowerCase().startsWith('diner') ? dinersclub : (
                                    this.state.cardType.toLowerCase().startsWith('jc') ? jcb :
                                      this.state.cardType.toLowerCase().startsWith('uni') ? unionpay: ''
                                  )
                                )
                              )
                            )
                          )}
                          style={{
                            position: 'absolute',
                            top: 30,
                            left: 103,
                            marginLeft: 10,
                            maxHeight: this.state.cardType.toLowerCase().startsWith('uni') || this.state.cardType.toLowerCase().startsWith('jcb') ? 30 : 60,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item lg={3} xs={12} style={style.fieldContainer}>
                      <InputField
                        name={"expiry"}
                        placeholder={"MM/YYYY"}
                        error={errors.expiry && touched.expiry}
                        errorMessage={errors.expiry}
                        label={"EXPIRY"}
                        type={"text"}
                        masked={true}
                        mask={"99/9999"}
                        style={{ width: "100%" }}
                      />
                    </Grid>
                    <Grid item lg={2} xs={12} style={style.fieldContainer}>
                      <InputField
                        name={"cvv"}
                        placeholder={"CVV"}
                        error={errors.cvv && touched.cvv}
                        errorMessage={errors.cvv}
                        label={"CVV"}
                        type={"text"}
                      />
                    </Grid>
                    <Grid item lg={12} style={style.fieldContainer}>
                      <InputField
                        name={"cardName"}
                        placeholder={"John Doe"}
                        error={errors.cardName && touched.cardName}
                        errorMessage={errors.cardName}
                        label={"NAME ON CARD"}
                        type={"text"}
                      />
                    </Grid>
                    <Grid item lg={12} style={{ textAlign: "left" }}>
                      <Fab
                       data-test-id={"savecard-id"}
                        variant={"extended"}
                        style={style.cardButton}
                        onClick={() => {
                          this.props.onSaveCard(values);
                          this.toggleCard();
                          setFieldValue('cardNumber', '', false);
                          setFieldValue('cardName', '', false);
                          setFieldValue('cvv', '', false);
                          setFieldValue('expiry', '', false);
                          this.setState({ cardType: '' });
                        }}
                      >
                        Save card
                      </Fab>
                    </Grid>
                  </Grid>
                )}
                <Hidden xsUp>
                  <Grid
                    item
                    lg={12}
                    style={{ textAlign: "center", marginTop: 10 }}
                  >
                    <Button className="remind-later-btn" data-test-id={"remind-id"} onClick={this.props.onSkip}>Remind me later</Button>
                    <Fab
                     data-test-id={"verifysub"}
                      variant={"extended"}
                      disabled={this.props.loading}
                      type="submit"
                      onClick={() => this.props.onVerify(values)}
                      style={
                        this.props.loading
                          ? style.submitButtonDisabled
                          : style.submitButton
                      }
                    >
                      Continue
                    </Fab>
                  </Grid>
                </Hidden>
                <Hidden xsDown>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    style={{ textAlign: "right", marginTop: 20 }}
                  >
                    <Button className="remind-later-btn" data-test-id={"remind-id"} onClick={this.props.onSkip}>Remind me later</Button>
                    <Fab
                      data-test-id={"verifysub"}
                      variant={"extended"}
                      disabled={this.props.loading}
                      type="submit"
                      id={"verify-submit"}
                      onClick={() => {
                        document.getElementById('verify-submit').disabled=true;
                        this.props.onVerify(values);
                      }}
                      style={
                        this.props.loading
                          ? style.submitButtonDisabled
                          : style.submitButton
                      }
                    >
                      Continue
                    </Fab>
                  </Grid>
                </Hidden>
                <Hidden smUp>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    style={{ textAlign: "right", marginTop: 20 }}
                  >
                    <Button className="remind-later-btn" onClick={this.props.onSkip}>Remind me later</Button>
                    <Fab
                      className="mt-5"
                      variant={"extended"}
                      disabled={this.props.loading}
                      type="submit"
                      id={"verify-submit"}
                      onClick={() => {
                        document.getElementById('verify-submit').disabled=true;
                        this.props.onVerify(values);
                      }}
                      style={
                        this.props.loading
                          ? style.submitButtonDisabled
                          : style.submitButton
                      }
                    >
                      Continue
                    </Fab>
                  </Grid>
                </Hidden>
              </Grid>
            </Form>
          )}
        </Formik>*/}
      </div>
    );
  }
}

export default VerifyChef;
